import {
  LOGIN_MODAL_RECEIVE,
  LOGIN_MODAL_SHOW,
  LOGIN_MODAL_CONTINUE_WITHOUT_LOGIN,
  LOGIN_MODAL_PREFFERED_ORG_ID,
  LOGIN_MODAL_ERROR,
  LOGIN_MODAL_OPEN_ORGANIZATION_SELECTOR,
} from '../constants';

const DEFAULT_STATE = {
  modalLoginData: {},
  isLoggedOnModal: false,
  loginSuccess: false,
  preferredOrgId: -1,
  currentOrganizationId: -1,
  continueWithoutLogin: false,
  visible: false,
  showOrganizationSelector: false,
  errorMessage: '',
  callbackOk: false,
};

export const loginModal = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LOGIN_MODAL_RECEIVE:
    case LOGIN_MODAL_SHOW:
    case LOGIN_MODAL_CONTINUE_WITHOUT_LOGIN:
    case LOGIN_MODAL_PREFFERED_ORG_ID:
    case LOGIN_MODAL_ERROR:
    case LOGIN_MODAL_OPEN_ORGANIZATION_SELECTOR:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
